import React from 'react';

function Intro() {
  return (
    <section className="intro section-padding">
      <style jsx>{`
        .intro {
          padding-top: 60px !important;
          padding-bottom: 60px !important;
        }
        @media screen and (max-width: 768px) {
          .intro {
            padding-top: 40px !important;
            padding-bottom: 40px !important;
          }
        }
      `}</style>
      <div className="container">
        <div className="row lg-marg">
          <div className="col-lg-8 md-mb80">
            <div className="numbers">
              <div className="row lg-marg">
                <div className="col-md-6">
                  <div className="item bord-thin-top d-flex align-items-end">
                    <div>
                      <h3 className="fw-300 mb-10">+6</h3>
                      <h6 className="p-color sub-title">
                        Años de experiencia
                      </h6>
                    </div>
                    <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="item bord-thin-top d-flex align-items-end">
                    <div>
                      <h3 className="fw-300 mb-10">+150</h3>
                      <h6 className="p-color sub-title">Puntos abastecidos</h6>
                    </div>
                    <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <style jsx>{`
                .numbers .row.lg-marg {
                  margin-left: -10px !important;
                  margin-right: -10px !important;
                }
                .numbers .row.lg-marg > * {
                  padding-left: 10px !important;
                  padding-right: 10px !important;
                }
                .numbers .item {
                  padding-top: 10px !important;
                  margin-top: 0 !important;
                  margin-bottom: 0 !important;
                }
                .numbers .row.lg-marg > .col-md-6:first-child {
                  margin-bottom: 25px !important;
                }
                @media screen and (max-width: 768px) {
                  .numbers .row.lg-marg {
                    margin-left: -10px !important;
                    margin-right: -10px !important;
                  }
                  .numbers .row.lg-marg > * {
                    padding-left: 10px !important;
                    padding-right: 10px !important;
                  }
                  .numbers .row.lg-marg > .col-md-6:first-child {
                    margin-bottom: 20px !important;
                  }
                  .numbers .item {
                    padding-top: 8px !important;
                  }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
